



































































import { Component, Vue } from "vue-property-decorator";
import {
  Import as IImport,
  ImportStatusEnum
} from "@/api-v2/import-export-2/models/import";
import { importExportApi } from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { ImportTypes } from "@/getinfo-api/imports2";
import ImportDetailInfo from "@/components/imports/ImportDetailInfo.vue";

@Component({
  components: { ImportDetailInfo, CustomButton, TextField, CBlock, CPage }
})
export default class ImportView extends Vue {
  importObject!: IImport;
  isLoading: boolean = false;
  interval: any = null;
  inWorking: boolean = false;

  data() {
    return {
      importObject: undefined
    };
  }

  getImport() {
    importExportApi.Import.getImport(this.$route.params.id).then(res => {
      this.importObject = res.data;
      if (
        this.importObject.status === "success" ||
        this.importObject.status === "fail"
      ) {
        clearInterval(this.interval);
        this.inWorking = false;
      }
    });
  }

  getStatus(status: ImportStatusEnum) {
    const result = {
      variant: "warning",
      text: `${this.$tc(this.$translate.Unknown)}`
    };

    if (status === ImportStatusEnum.Waiting) {
      result.text = `${this.$tc(this.$translate.InProcessing)}`;
      result.variant = "warning";
    }

    if (status === ImportStatusEnum.Started) {
      result.text = `${this.$tc(this.$translate.InProcessing)}`;
      result.variant = "info";
    }

    if (status === ImportStatusEnum.Success) {
      result.text = `${this.$tc(this.$translate.Success)}`;
      result.variant = "success";
    }

    if (status === ImportStatusEnum.Fail) {
      result.variant = "danger";
      result.text = `${this.$tc(this.$translate.Error)}`;
    }

    return result;
  }

  getImportType(type: ImportTypes) {
    if (type === ImportTypes.CourseV1JSON)
      return `${this.$tc(this.$translate.Course)}`;

    if (type === ImportTypes.UserCSV)
      return `${this.$tc(this.$translate.Users)}`;

    if (type === ImportTypes.StudentCSV)
      return `${this.$tc(this.$translate.Students)}`;

    if (type === ImportTypes.ContractorCSV)
      return `${this.$tc(this.$translate.Contractors)}`;

    if (type === ImportTypes.LaborProtectionWorkerImport)
      return `${this.$tc(this.$translate.LaborProtectionWorker)}`;

    return `${this.$tc(this.$translate.Unknown)}`;
  }

  created() {
    this.inWorking = true;
    this.interval = setInterval(this.getImport, 5000);
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }
}
